import { render, staticRenderFns } from "./UpdateUnitAddress.vue?vue&type=template&id=488fd4ea&scoped=true";
import script from "./UpdateUnitAddress.vue?vue&type=script&lang=js";
export * from "./UpdateUnitAddress.vue?vue&type=script&lang=js";
import style0 from "./UpdateUnitAddress.vue?vue&type=style&index=0&id=488fd4ea&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "488fd4ea", null);
export default component.exports;